<button
  mat-icon-button
  class="mobile-menu-button"
  aria-label="Open navigation menu"
  [matMenuTriggerFor]="mobileMenu"
  *ngIf="!isLoading && currentUser"
>
  <mat-icon>menu</mat-icon>
  <span class="menu-notification" *ngIf="hasNotifications()">!</span>
</button>

<mat-menu class="mobile-menu-panel" #mobileMenu="matMenu">
  <ng-container *ngFor="let menuItem of menuItems">
    <a
      mat-menu-item
      *ngIf="
        (!menuItem.hide || currentUser) &&
        menuItem.routerLink &&
        menuItem.type != menuItemTypes.PopUp &&
        menuItem.type != menuItemTypes.Submenu &&
        menuItem.type != menuItemTypes.Table &&
        ((menuItem.route == 'pending-approvals' &&
          notificationCount() > 0 &&
          currentUser) ||
          menuItem.route != 'pending-approvals')
      "
      [routerLink]="menuItem.routerLink"
    >
      {{ menuItem.name }}
      <span
        class="notfication"
        *ngIf="
          menuItem.route == 'pending-approvals' &&
          pendingApprovals &&
          currentUser
        "
        >{{ pendingApprovals }}</span
      >
      <span
        class="notfication-my"
        *ngIf="
          menuItem.route == 'pending-approvals' &&
          myPendingChanges &&
          currentUser
        "
        >{{ myPendingChanges }}</span
      >
    </a>
    <button
      mat-menu-item
      *ngIf="
        (!menuItem.hide || currentUser) &&
        menuItem.type == menuItemTypes.PopUp
      "
      (click)="openComponent(menuItem.route ?? '')"
    >
      {{ menuItem.name }}
    </button>
    <ng-container
      *ngIf="
        (!menuItem.hide || currentUser) &&
        (menuItem.type == menuItemTypes.Submenu ||
          menuItem.type == menuItemTypes.Table)
      "
    >
      <button mat-menu-item [matMenuTriggerFor]="sub.menu">
        {{ menuItem.name }}
        <span
          class="notfication-pending"
          *ngIf="
            menuItem.code == 'procedures' && sub.pendingTrainings && currentUser
          "
          >{{ sub.pendingTrainings }}</span
        >
        <span
          class="notfication"
          *ngIf="
            menuItem.code == 'procedures' && sub.missingTrainings && currentUser
          "
          >{{ sub.missingTrainings }}</span
        >
      </button>
      <head-menu-mobile-submenu
        #sub
        [menuItem]="menuItem"
      ></head-menu-mobile-submenu>
    </ng-container>
  </ng-container>
</mat-menu>
